import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url, config.data);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.data);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error.response?.status, error.response?.data, error.message);
    return Promise.reject(error);
  }
);

export const quizAPI = {
  getQuestions: () => api.get('/api/questions'),
  createStudent: (name) => api.post('/api/students', { name }),
  getStudentByName: (name) => api.get(`/api/students/${name}`),
  updateStudent: (student) => api.put(`/api/students/${student.id}`, student),
  getAllStudents: () => api.get('/api/admin/students'),
  deleteStudent: (id) => api.delete(`/api/admin/students/${id}`),
  getAveragePercentage: () => api.get('/api/admin/average'),
  downloadCSV: () => api.get('/api/admin/csv', { responseType: 'blob' }),
};

export const authAPI = {
  login: async (credentials) => {
    try {
      return await api.post('/api/admin/login', credentials);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 404 || status === 405) {
        return await api.post('/api/auth/login', credentials);
      }
      throw err;
    }
  },
};

export default api;
